<template>
    <div>
        <router-view></router-view>

        <div
            id="rightbar"
            v-click-outside="away"
            :class="patientsOpen ? 'opened' : 'closed'"
        >
            <div class="btn-rightbar">
                <a class @click="togglePatients()">
                    <i class="fa fa-2x fa-bars"></i>
                </a>
            </div>
            <div class="list-header">
                <span>
                    <i class="fa fa-lg fa-address-book"></i>
                </span>
                <span>Yatan Hastalar</span>
                <a class="btn link-blue" @click.prevent="getList()">
                    <i class="fa fa fa-sync"></i> Yenile
                </a>
                <div class="patient-tabs">
                    <ul>
                        <li
                            @click.prevent="setTabActive('Servis')"
                            :class="{ active: isTabActive('Servis') }"
                        >
                            Servis
                        </li>
                        <li
                            @click.prevent="setTabActive('YogunBakim')"
                            :class="{ active: isTabActive('YogunBakim') }"
                        >
                            Yoğun Bakım
                        </li>
                    </ul>
                </div>
            </div>

            <div class="patient-tab-content" v-show="isTabActive('Servis')">
                <perfect-scrollbar>
                    <ul class="patients">
                        <template v-for="s in servis_patients">
                            <div class="yeri" :key="s.id">
                                <p>{{ s.yeri }}</p>
                                <span>
                                    <b>{{ s.patients.length }}</b>
                                </span>
                            </div>
                            <router-link
                                v-for="p in s.patients"
                                :key="p.id"
                                tag="li"
                                @click.native="away"
                                :class="[
                                    p.id == selectedPatientID ? 'selected' : '',
                                    patient_status(p.progress),
                                ]"
                                :to="'/patients/servis/' + p.id"
                            >
                                <div class="col-gun">
                                    <p class="gun">
                                        {{ p.yatis | toOnlyGun }}.
                                    </p>
                                    <p>GÜN</p>
                                </div>
                                <div class="col-name">
                                    {{ p.name }}
                                    <br />
                                    <span class="tanilar">{{ p.tanilar }}</span>
                                </div>
                            </router-link>
                        </template>
                        <div class="empty" v-if="!servis_patients.length">
                            <div class="small-empty">
                                <i class="fa fa-info-circle fa-3x"></i>
                                <span>Serviste Yatan Hasta Yok</span>
                            </div>
                        </div>
                    </ul>
                </perfect-scrollbar>
            </div>
            <div class="patient-tab-content" v-show="isTabActive('YogunBakim')">
                <perfect-scrollbar>
                    <ul class="patients">
                        <div class="yeri">
                            <p>YENİDOĞAN YOĞUN BAKIM</p>
                            <span>
                                <b>{{ yd_patients.length }}</b>
                            </span>
                        </div>
                        <draggable v-model="yd_patients" v-bind="dragOptions">
                            <transition-group
                                type="transition"
                                name="flip-list"
                            >
                                <router-link
                                    v-for="p in yd_patients"
                                    :key="p.id"
                                    tag="li"
                                    @click.native="away"
                                    :class="[
                                        p.id == selectedPatientID
                                            ? 'selected'
                                            : '',
                                        patient_status(p.progress),
                                    ]"
                                    :to="'/patients/yogunbakim/' + p.id"
                                >
                                    <div class="col-gun">
                                        <p class="gun">
                                            {{ p.yatis | toOnlyGun }}.
                                        </p>
                                        <p>GÜN</p>
                                    </div>
                                    <div class="col-name">
                                        {{ p.name }}
                                        <br />
                                        <span class="tanilar">{{
                                            p.tanilar
                                        }}</span>
                                    </div>
                                </router-link>
                            </transition-group>
                        </draggable>
                        <div class="ozet" v-if="!yd_patients.length">
                            <div><span class="adet c-red">12</span> Entübe</div>

                            <div>
                                <span class="adet c-orange-dark">5</span> nCPAP
                            </div>
                        </div>
                        <div class="empty" v-if="!yd_patients.length">
                            <div class="small-empty">
                                <i class="fa fa-info-circle fa-3x"></i>
                                <span>Yenidoğanda Yatan Hasta Yok</span>
                            </div>
                        </div>
                    </ul>
                    <ul class="patients">
                        <template v-for="s in yb_patients">
                            <div class="yeri" :key="s.id">
                                <p>YOĞUN BAKIM</p>
                                <span>
                                    <b>{{ s.patients.length }}</b>
                                </span>
                            </div>
                            <router-link
                                v-for="p in s.patients"
                                :key="p.id"
                                tag="li"
                                @click.native="away"
                                :class="[
                                    p.id == selectedPatientID ? 'selected' : '',
                                    patient_status(p.progress),
                                ]"
                                :to="'/patients/servis/y/' + p.id"
                            >
                                <div class="col-gun">
                                    <p class="gun">
                                        {{ p.yatis | toOnlyGun }}.
                                    </p>
                                    <p>GÜN</p>
                                </div>
                                <div class="col-name">
                                    {{ p.name }}
                                    <br />
                                    <span class="tanilar">{{ p.tanilar }}</span>
                                </div>
                            </router-link>
                        </template>
                        <div class="empty" v-if="!yb_patients.length">
                            <div class="small-empty">
                                <i class="fa fa-info-circle fa-3x"></i>
                                <span>Yoğun Bakımda Yatan Hasta Yok</span>
                            </div>
                        </div>
                    </ul>
                    <ul class="khd">
                        <div v-if="births.length" class="yeri">
                            <p>KHD SERVİSİ</p>
                            <span>
                                <b>{{ births.length }}</b>
                            </span>
                        </div>
                        <li v-for="p in births" :key="p.id" class="">
                            <div class="warning blink">
                                <i class="fa fa-2x fa-exclamation"></i>
                            </div>
                            <div class="col-name">
                                <span class="name">{{ p.bebek }}</span>
                                <span class="detail">{{ p.coombs }}</span>
                                <span class="detail">{{
                                    p.birth | moment("DD.MM.YYYY HH:mm")
                                }}</span>
                            </div>
                            <div class="col-gun">
                                <p class="gun">
                                    {{
                                        inhours(p.birth) != 0
                                            ? inhours(p.birth)
                                            : 0
                                    }}.
                                </p>
                                <p>SAAT</p>
                            </div>
                        </li>
                    </ul>
                </perfect-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import draggable from "vuedraggable";
import _ from "lodash";
export default {
    name: "Patients",
    components: {
        draggable,
    },
    data() {
        return {
            selectedPatient: [],
            sprogress: [],
            patientsOpen: false,
            drag: false,
            activeTab: this.$router.currentRoute.name,
        };
    },
    computed: {
        patientList() {
            return this.$store.getters.getPatients;
        },
        births() {
            return this.$store.getters.getKHD;
        },
        doctors() {
            return this.$store.getters.getDoctors;
        },
        user() {
            return this.$store.getters.getUser;
        },
        sablon() {
            return this.$store.getters.getSablon;
        },
        servis_patients() {
            var result = _.chain(this.patientList.servis)
                .groupBy("yeri")
                .map((value, key) => ({
                    yeri: this.$store.getters.getServis(key),
                    patients: value,
                }))
                .value();
            return result;
        },
        yb_patients() {
            var result = _.chain(this.patientList.yb)
                .groupBy("yeri")
                .map((value, key) => ({
                    yeri: this.$store.getters.getServis(key),
                    patients: value,
                }))
                .value();
            return result;
        },
        yd_patients: {
            get() {
                return this.patientList.yd;
            },
            set(value) {
                var sirali = value;
                var i = 0;
                sirali.forEach((sirali) => {
                    sirali.kuvoz = i;
                    i = i + 1;
                });
                var veri = JSON.parse(JSON.stringify(this.patientList.yd));
                this.$http({
                    method: "post",
                    url: "api/yenidogan/sirala.php",
                    data: qs.stringify(veri),
                }).then(() => {
                    this.$snotify.success("Hasta sıralaması güncellendi");
                    this.$socket.client.emit("update", "patients");
                    this.$store.dispatch("fillPatients");
                });
            },
        },
        selectedPatientID() {
            if (this.selectedPatient.length) {
                return this.selectedPatient[0].id;
            } else {
                return -1;
            }
        },
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
                delay: 1000, // time in milliseconds to define when the sorting should start
                delayOnTouchOnly: true,
            };
        },
    },
    methods: {
        // Tabs
        isTabActive(menuItem) {
            return this.activeTab === menuItem;
        },
        setTabActive(menuItem) {
            this.activeTab = menuItem;
        },
        // İlaçlar
        backToIlacList() {
            this.aktifIlac = 0;
        },
        getIlac(ilac) {
            this.aktifIlac = ilac;
        },
        setModifiedDevir(m) {
            this.modifiedDevir = m;
        },
        // Hasta Listesi
        away: function () {
            if (this.patientsOpen) {
                this.patientsOpen = false;
            }
        },
        togglePatients() {
            this.patientsOpen = !this.patientsOpen;
        },
        patient_status(p) {
            var r = "";
            switch (parseInt(p)) {
                case 1:
                    r = "finished";
                    break;
                case 0:
                    r = "unfinished";
                    break;
                case -1:
                    r = "taburcu";
                    break;
            }
            return r;
        },
        coombs_color() {
            var r = "";
            switch (this.selectedPatient[0].coombs) {
                case "D.Coombs (-)":
                    r = "c-green";
                    break;
                default:
                    r = "c-red";
                    break;
            }
            return r;
        },
        getList() {
            this.$store.dispatch("fillPatients");
            this.$store.dispatch("fillKHD");
        },
        navigatePatientYD(p) {
            this.$router
                .push({ path: `/patients/yenidogan/${p}` })
                .catch(() => {
                    const path = `/patients/yenidogan/${p}`;
                    if (this.$route.path !== path) this.$router.push(path);
                });
        },
        navigatePatientServis(p) {
            this.$router.push({ path: `/patients/servis/${p}` }).catch(() => {
                const path = `/patients/servis/${p}`;
                if (this.$route.path !== path) this.$router.push(path);
            });
        },

        inhours(b) {
            var bd = this.$moment(b);
            var nd = this.$moment(new Date());
            return nd.diff(bd, "hours");
        },
    },
    created() {
        //this.getBirths();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.activeTab = to.name;
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.activeTab = to.name;
        next();
    },
};
</script>

<style lang="scss">
</style>